import type { ProvinceFull } from "@/store/types/province";

export interface AddressLookupQueryDto {
  text: string;
  container: string;
}

export interface AddressLookupDto {
  id: string;
  text: string;
  type: string;
}

export interface AddressLookupDetailsDto {
  text: string;
  city: string;
  province: ProvinceFull;
  postalCode: string;
}

export interface GetProductCategoriesDto {
  ada: string;
  province?: ProvinceFull;
}

export interface ProductDto {
  id: 1 | 2 | 3 | 4 | 5;
  name: string;
  price: number;
  minimumQuantity: number;
}

export interface ProductCategoryDto {
  id: number;
  name: string;
  products: ProductDto[];
}

export interface OrderCreatedDto {
  id: number;
  orderId: string;
  externalId: string;
  paymentUrl: string;
}

export interface OrderValidateDto {
  id: number;
  orderId: string;
  externalId: string;
  success: boolean;
  message: string;
}

export interface OrderContactAddressDto {
  id: number;
  name: string;
  businessName: string;
  streetAddress: string;
  unitSuiteEtc: string;
  city: string;
  province: ProvinceFull | "";
  postalCode: string;
  addressType: string;
  allowPo: boolean;
}

export interface OrderContactDto {
  ada: string;
  phoneNumber: string;
  email: string;
  sameAsBillingAddress: boolean;
  billingAddresses: OrderContactAddressDto[];
  shippingAddresses: OrderContactAddressDto[];
}

export interface EmergentVerifyEmailDto {
  email: string;
  language: string;
  captchaToken: string;
}

export interface IndigenousCommunityProvinceListDto {
  province: ProvinceFull;
  communities: IndigenousCommunitySimpleListDto[];
}

export interface IndigenousCommunitySimpleListDto {
  id: number;
  name: string;
}

export interface IndigenousCommunityStatusDto {
  activated: boolean;
}

export interface AdaLoginDto {
  ada: string;
  province?: ProvinceFull;
  communityId: number;
  captchaToken: string;
}

export interface AdaLoginResponseDto extends OrderContactDto {}

export interface PromoCodeDto {
  id: number;
  code: string;
  discountAmount: number;
  dateCreated: string;
}

export enum FeedbackSentiment {
  ThumbsUp = 1,
  ThumbsDown = 2,
}

export interface CreateFeedbackDto {
  orderId: number;
  comment: string;
  email?: string;
  sentiment: FeedbackSentiment;
}
